import { useCallback } from "react";
import { Link } from "react-router";

import { useCopyToClipboard } from "@/lib/react-use/use-copy-to-clipboard";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { Button } from "@/components/ui/button/button";
import OpenInNew from "@/components/ui/icon/open-in-new";

type Props = {
	hotelID: string;
};
const WEB_HOOK_URL = import.meta.env.VITE_BEDS24_WEBHOOK_URL as string;

export const SettingsSiteControllerBeds24WebHookUrl = ({ hotelID }: Props) => {
	const webhookUrl = `${WEB_HOOK_URL}/${hotelID}`;

	const { copy } = useCopyToClipboard();
	const handleClick = useCallback(() => {
		copy(webhookUrl);

		notifyUserEventInfo({
			title: "Webhook URLをコピーしました",
		});
	}, [copy, webhookUrl]);

	return (
		<QuestionForMain
			required={true}
			title={"Webhook URLの設定"}
			inputChildren={
				<div className="space-y-8">
					<div className="flex items-center gap-x-6">
						<p className="select-all">{webhookUrl}</p>
						<Button type="button" variant="outline" size="sm" onClick={handleClick}>
							コピー
						</Button>
					</div>
					<div className="space-y-2">
						<div className="flex gap-x-2">
							※
							<Link
								to={"https://beds24.com/control3.php?pagetype=syncroniserwebhooks"}
								target="_blank"
								className="flex items-center gap-x-1 text-link-400 underline-offset-4 hover:underline"
								viewTransition
							>
								Beds24管理画面（Inventory Webhooks）
								<OpenInNew className="w-5" />
							</Link>
							で Webhook URL を入力してください
						</div>
						<div className="text-brand">
							<div className="flex">
								<p>※</p>
								<div>
									<p>
										すでにWebhook
										URLが記載されている場合、上書きせずにBeds24メールサポートにCHILLNNのWebhook
										URLの登録をご依頼ください。
									</p>
									<p>Beds24サポートでURLの登録作業を行います。</p>
								</div>
							</div>
						</div>
						<div className="text-sm">
							<p>※ カスタムヘッダーの指定は不要です</p>
							<p>
								※ Webhook
								URLはホテルごとに異なるものが発行されています。連携したいホテルに設定されているかご確認ください。
							</p>
							<p className="text-brand">
								※ 紐付けたい全ての部屋の同期設定で「有効にする」にチェックを入れてください
							</p>
						</div>
					</div>
				</div>
			}
		/>
	);
};

SettingsSiteControllerBeds24WebHookUrl.displayName = "SettingsSiteControllerBeds24WebHookUrl";
